import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { SidebarLeftCollapseIcon } from 'foundations-assets/icons/components/SidebarLeftCollapseIcon';
import { SidebarLeftExpandIcon } from 'foundations-assets/icons/components/SidebarLeftExpandIcon';
import { MobilePopover } from './MobilePopover';
import { usePageLinks } from '../hooks/usePageLinks';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuNode = ({
  node,
  depth,
  setOpen
}) => {
  var _node$linkTarget, _node$children;
  const [localOpen, setLocalOpen] = useState(false);
  const hasChildren = Array.isArray(node.children) && node.children.length;
  const isOpenInNewTab = node.linkTarget === '_blank';
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      paddingInlineStart: depth ? '600' : undefined,
      gap: "400",
      children: [/*#__PURE__*/_jsx("div", {
        children: node.url ? /*#__PURE__*/_jsx(Button, {
          use: "transparent",
          href: node.url,
          external: isOpenInNewTab,
          target: (_node$linkTarget = node.linkTarget) !== null && _node$linkTarget !== void 0 ? _node$linkTarget : undefined,
          onClick: () => setOpen(false),
          children: /*#__PURE__*/_jsx(Text, {
            color: "text-core-default",
            children: node.label
          })
        }) : /*#__PURE__*/_jsx(Text, {
          paddingBlock: "250",
          paddingInline: "300",
          color: "text-core-default",
          children: node.label
        })
      }), /*#__PURE__*/_jsx("div", {
        children: hasChildren ? /*#__PURE__*/_jsx(IconButton, {
          onClick: () => setLocalOpen(prev => !prev),
          shape: "square",
          use: "secondary-alt",
          "aria-label": localOpen ? unescapedText('customer-portal-app.panel.collapseTooltip') : unescapedText('customer-portal-app.panel.expandTooltip'),
          "aria-expanded": localOpen,
          children: localOpen ? /*#__PURE__*/_jsx(SidebarLeftCollapseIcon, {
            size: "500"
          }) : /*#__PURE__*/_jsx(SidebarLeftExpandIcon, {
            size: "500"
          })
        }) : /*#__PURE__*/_jsx("div", {
          "aria-hidden": "true",
          style: {
            visibility: 'hidden'
          },
          children: /*#__PURE__*/_jsx(IconButton, {
            shape: "square",
            use: "secondary-alt",
            children: /*#__PURE__*/_jsx(SidebarLeftExpandIcon, {
              size: "500"
            })
          })
        })
      })]
    }), hasChildren && localOpen ? (_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.map((child, index) => /*#__PURE__*/_jsx(MenuNode, {
      node: child,
      depth: depth + 1,
      setOpen: setOpen
    }, `${node.label}-${child.label}-${index}`)) : null]
  });
};
export const MobileNavigationMenu = () => {
  const [open, setOpen] = useState(false);
  const menuChildren = usePageLinks();
  if (!menuChildren.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(MobilePopover, {
    title: I18n.text('customer-portal-app.menuLabel'),
    open: open,
    onOpenChange: setOpen,
    content: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "300",
      padding: "800",
      children: menuChildren.map(node => /*#__PURE__*/_jsx(MenuNode, {
        node: node,
        depth: 0,
        setOpen: setOpen
      }, node.label))
    }),
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        "aria-label": unescapedText('customer-portal-app.menuLabel'),
        "aria-expanded": open,
        onClick: () => setOpen(o => !o),
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          gap: "200",
          children: /*#__PURE__*/_jsx(VerticalMenuIcon, {
            color: "text-core-default"
          })
        })
      })
    })
  });
};